export class RegistroIngSalActivoFijo {
  constructor(
    public clasificacionActivoFijo: string,
    public DescripcionActivoFijo: string,
    public tipoActivoFijo: string,
    public serialActioFijo: string,
    public estadoActivoFijo: string,
    public propietarioActivoFijo: string,
    public observacionesActivoFijo: string,
    public marcaActivoFijo: string,
    public idActivo?: string,
    public numeroDocumentoFuncionario?: string,
    public perteneceA?: string,
    public serialActivoFijo?: string,
    public numeroIngresos?: number,
    public descripcionActivoFijo?: string,
    public fechaUltimoIngreso?: Date,
    public sede?: string,
    public idRegIngSalActivoFijo?: number,
    public idActivoFijo?: number,
    public placaInventario?: string,
    public tipoDocumentoFuncionario?: string,
    public fechaUltimaSalida?: Date,
    ) { }

    
}
